// import axios from 'axios';
import axios from '@/utils/request';
// axios.defaults.headers['Content-Type'] = 'application/json;charset=utf-8;'
import {
  web_url
} from '../api/baseUrl';
import qs from 'qs';
import {getTenantId} from "../utils/auth";

// 登录请求方法
const loginreq = (method, url, params) => {
  url = replaceUndefined(url)
  return axios({
    method: method,
    // url:web_url + url,
    url: '/admin-api' + url,
    headers: {
      // 'Content-Type': 'application/x-www-form-urlencoded',
      'Content-Type': 'application/json',
      'Tenant-Id': getTenantId(),
    },
    data: params,
    traditional: true,
  }).then(res => res.data);
};
//移除undefined传参
const replaceUndefined = (url) => {
  if (url.indexOf("undefined") > -1) {
    url = url.replace("undefined", "");
  }
  if (url.indexOf("/api") > -1) {
    url = url.replace("/api", "");
  }
  return url
};
// 通用公用方法
const req = (method, url, params) => {
  url = replaceUndefined(url)
  return axios({
    method: method,
    url: web_url + url,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8',
      'Tenant-Id': getTenantId(),
      'Authorization': localStorage.getItem('logintoken')
    },
    data: params,
    traditional: true,
    transformRequest: [
      function (data) {

        let ret = ''
        for (let it in data) {
          ret +=
            encodeURIComponent(it) +
            '=' +
            encodeURIComponent(data[it]) +
            '&'
        }
        return ret
      }
    ]
  }).then(res => res.data);
};
const req1 = (method, url, params) => {
  url = replaceUndefined(url)
  // GET 请求自动拼接参数到 URL
  if (method.toLowerCase() === 'get' && params) {
    const queryString = qs.stringify(params, {addQueryPrefix: true, arrayFormat: 'comma'});
    url = url + queryString;
  }
  return axios({
    method: method,
    url: url,
    data: method.toLowerCase() === 'get' ? null : params,
    traditional: true
  }).then(res => res.data);
};
// const req2 = (method, url, params) => {

//   return axios({
//     method: method,
//     url: url,
//     headers: {
//       "content-type": "application/json",
//     },
//     data: params,
//     traditional: true,
//     transformRequest: [
//       function (data) {

//         let ret = ''
//         for (let it in data) {
//           ret +=
//             encodeURIComponent(it) +
//             '=' +
//             encodeURIComponent(data[it]) +
//             '&'
//         }
//         return ret
//       }
//     ]
//   }).then(res => res.data);
// };
const req2 = (method, url, params) => {

  return axios({
    method: method,
    url: url,
    data: params,
    traditional: true
  }).then(res => res.data);
};
export {
  loginreq,
  req,
  req1,
  req2
}



// WEBPACK FOOTER //
// ./src/api/axiosFun.js